module.exports = __webpack_public_path__ + "img/chadle_adv_11.a14df8a8.png";